import React from "react";

import { BrandLogo } from "./brand/BrandLogo";

interface AppHandoffProps {
  title?: string;
  description?: string;
}

export const AppHandoff = ({
  title = "Getting ActivityViz ready",
  description = "Restoring your activity workspace.",
}: AppHandoffProps) => (
  <section
    aria-busy="true"
    aria-live="polite"
    className="flex min-h-full w-full flex-1 items-center justify-center px-6 py-12 text-center"
    role="status"
  >
    <div className="max-w-sm space-y-4">
      <BrandLogo
        className="mx-auto"
        markClassName="h-14 w-14"
        showTagline={false}
        textClassName="hidden"
      />
      <span
        aria-hidden="true"
        className="mx-auto block h-5 w-5 animate-spin rounded-full border-2 border-[var(--color-border-strong)] border-t-[var(--color-action-primary)] motion-reduce:animate-none"
      />
      <div>
        <h1 className="font-[family-name:var(--font-family-display)] text-xl font-medium tracking-[-0.02em] text-[var(--color-content-primary)]">
          {title}
        </h1>
        <p className="mt-1 text-sm text-[var(--color-content-secondary)]">{description}</p>
      </div>
    </div>
  </section>
);
